import { useTranslation } from "react-i18next"


export default function LeaveReportTable({
    leaveReport,
    showRatios = true,
    showAvailability = false
}) {
    const [t, i18n] = useTranslation(["global", "absenceReport"])

    return <table className="table  table-hover  small">
        <tbody>
            <tr >
                {
                    showRatios &&
                    <th className="opacity-25">{t("absenceReport:entity.leaveReport.property.ratio")}</th>
                }

                <th className="opacity-25"></th>

                <th className="opacity-25">{t("absenceReport:entity.leaveReport.property.prev_y")}</th>
                <th className="opacity-25">{t("absenceReport:entity.leaveReport.property.matured")}</th>
                <th className="opacity-25">{t("absenceReport:entity.leaveReport.property.used")}</th>
                <th className="text-accent">{t("absenceReport:entity.leaveReport.property.balance")}</th>
                {
                    showAvailability && <>
                        <th className="opacity-25">Prenotate</th>
                        <th className="text-primary">Disponibili</th>
                    </>
                }

            </tr>
            <tr>
                {
                    showRatios &&
                    <td className="opacity-50">{leaveReport.holidays.ratio}</td>
                }
                <th className="text-light">{t("absenceReport:entity.leaveReport.type.holidays")}</th>
                <td>{leaveReport.holidays.ap}</td>
                <td>{leaveReport.holidays.matured}</td>
                <td>{leaveReport.holidays.taken}</td>
                <SmartCell value={leaveReport.holidays.balance} />
                {
                    showAvailability && <>
                        <ValueOrNothingCell value={leaveReport.holidays.toTake}/>
                        <SmartCell value={leaveReport.holidays.available} />
                    </>
                }
            </tr>
            <tr>
                {
                    showRatios &&
                    <td className="opacity-50">{leaveReport.timeOff.ratio}</td>
                }
                <th className="text-light">{t("absenceReport:entity.leaveReport.type.timeOff")}</th>
                <td>{leaveReport.timeOff.ap}</td>
                <td>{leaveReport.timeOff.matured}</td>
                <td>{leaveReport.timeOff.taken}</td>
                <SmartCell value={leaveReport.timeOff.balance} />
                {
                    showAvailability && <>
                     <ValueOrNothingCell value={leaveReport.timeOff.toTake}/>
                        <SmartCell value={leaveReport.timeOff.available} />
                    </>
                }
            </tr>
            <tr>
                {
                    showRatios &&
                    <td className="opacity-50">{leaveReport.abolished.ratio}</td>
                }
                <th className="text-light">{t("absenceReport:entity.leaveReport.type.abolished")}</th>
                <td>{leaveReport.abolished.ap}</td>
                <td>{leaveReport.abolished.matured}</td>
                <td>{leaveReport.abolished.taken}</td>
                <SmartCell value={leaveReport.abolished.balance} />
                {
                    showAvailability && < >
                        <ValueOrNothingCell value={leaveReport.abolished.toTake}/>
                        <SmartCell value={leaveReport.abolished.available} className="opacity-50"/>
                    </>
                }
            </tr>
        </tbody>
    </table>
}

function ValueOrNothingCell({ value }) {

    function getCellColor() {
        if (value == 0)
            return "opacity-25"
    }

    return <td className={getCellColor()}>{value>0?value:"-"}</td>

}

function SmartCell({ value }) {

    function getCellColor() {
        if (value < 0)
            return "bg-danger bg-opacity-25"
    }

    return <td className={getCellColor()}>{value}</td>

}